import { Component, Signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import {
    RideTypeService,
    RoutingHelpersService,
} from '@polaris-customerweb/sharedcomponents.shared';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AnalyticsDirective } from 'src/app/directives/analytics.directive';
import { UserAuthService } from 'src/app/state/user-auth/user-auth.service';

@Component({
    imports: [
        AnalyticsDirective,
        AngularSvgIconModule,
        RouterLink,
        RouterLinkActive,
    ],
    selector: 'rdx-primary-nav',
    styleUrls: ['./primary-nav.component.scss'],
    templateUrl: './primary-nav.component.html',
})
export class PrimaryNavComponent {
    homeUrl: string;
    brand: string;
    garageIcon: string;
    isEpi: boolean;
    isAuthenticated: boolean;
    $isMapTypeSno: Signal<boolean>;
    loggedOutGarageUrl: string;
    rideCommandPlusUrl: string;

    constructor(
        configService: ConfigService,
        routingHelpersService: RoutingHelpersService,
        private rideTypeService: RideTypeService,
        userAuthService: UserAuthService
    ) {
        this.brand = configService.brand;
        this.rideCommandPlusUrl = routingHelpersService.getUrlWithCulture(
            '/ride-command-plus/'
        );
        this.isEpi = configService.isEmbedded;

        userAuthService.isAuthenticated$.subscribe((isAuthenticated) => {
            this.isAuthenticated = isAuthenticated;
            if (this.isEpi && !isAuthenticated) {
                this.homeUrl = configService.siteUrl;
                this.loggedOutGarageUrl = routingHelpersService.combineUrl(
                    configService.siteUrl,
                    'garage/'
                );
            }
        });

        this.$isMapTypeSno = this.rideTypeService.$isSnoRideType;
    }
}
